var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSysCongratulations = function SvgSysCongratulations(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M13.6 11.3h.023M55 22.8h.023M38.9 9h.023M53 50.4h.023M55 9l-5.152 1.725a6.67 6.67 0 0 0-4.508 7.176c.23 1.978-1.311 3.749-3.335 3.749h-.874c-1.978 0-3.68 1.38-4.048 3.312L36.6 27.4M55 34.3l-1.886-.759c-1.978-.782-4.186.46-4.554 2.553a3.336 3.336 0 0 1-3.289 2.806H43.5M29.7 9l.759 1.886c.782 1.978-.46 4.186-2.553 4.554-1.61.23-2.806 1.656-2.806 3.289V20.5M18.408 28.508 9 55l26.492-9.383"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M31.283 32.717c4.778 4.779 7.007 10.325 4.952 12.38-2.055 2.055-7.601-.174-12.38-4.952-4.778-4.779-7.006-10.325-4.951-12.38 2.055-2.054 7.6.174 12.379 4.952Z"
  })));
};
export default SvgSysCongratulations;